import React from "react";
import DocumentDetail from "../common/DocumentDetail";
import { BLANK_PLACEHOLDER } from "config/constant";
import { CORP_CARD_USAGE_PROOF_FIELD as FIELD } from "config/documentConstant";
import { DocumentDtoWithAny } from "models/document/DocumentDtoWithAny";
import { Text, View } from "@react-pdf/renderer";
import formatNumber from "../../../../utils/formatUtils/formatNumber";

interface CorpCardUsageProofDetailProps {
  documentData: DocumentDtoWithAny["documentData"];
  companyName: DocumentDtoWithAny["companyName"];
  author: DocumentDtoWithAny["author"];
}

const CorpCardUsageProofDetail = ({
  documentData,
  companyName,
  author,
}: CorpCardUsageProofDetailProps) => {
  const details = documentData[FIELD.USAGE_DETAILS.key].map((item: any) => [
    item.amount || BLANK_PLACEHOLDER,
  ]);
  const rawUsageClients = documentData[FIELD.USAGE_CLIENTS.key];
  const usageClients = Array.isArray(rawUsageClients)
    ? rawUsageClients
    : rawUsageClients
      ? [rawUsageClients] // 객체가 오면 한 건짜리 배열로 변환
      : []; // 아무 값도 없으면 빈 배열
  const clients = usageClients.map((item: any) => [
    item.clientsDescription || BLANK_PLACEHOLDER,
    item.number || BLANK_PLACEHOLDER,
  ]);
  const labels = FIELD.USAGE_CLIENTS.itemFields.map((f) => f.label);

  // 증빙 사유 유형: 다중 선택(배열) 및 기존 단일 문자열 모두 수용
  const rawUsageType = documentData[FIELD.USAGE_TYPE.key];
  const usageTypeText = Array.isArray(rawUsageType)
    ? rawUsageType.join(", ")
    : rawUsageType;

  return (
    <>
      <div>
        <DocumentDetail.Section>
          <DocumentDetail.Field label="법인명">
            <Text
              style={{
                fontFamily: "Pretendard",
                fontSize: "10pt",
              }}
            >
              {companyName}
            </Text>
          </DocumentDetail.Field>

          <DocumentDetail.Field label="사용자">
            <View style={{ display: "flex", flexDirection: "row" }}>
              <View style={{ flex: 1 }}>
                <Text
                  style={{
                    fontFamily: "Pretendard",
                    fontSize: "10pt",
                  }}
                >
                  {author}
                </Text>
              </View>
            </View>
          </DocumentDetail.Field>

          <DocumentDetail.Field label={FIELD.USAGE_DATE.label}>
            <DocumentDetail.Value.Date>
              <Text
                style={{
                  fontFamily: "Pretendard",
                  fontSize: "10pt",
                }}
              >
                {documentData[FIELD.USAGE_DATE.key] || BLANK_PLACEHOLDER}
              </Text>
            </DocumentDetail.Value.Date>
          </DocumentDetail.Field>

          <DocumentDetail.Field label={FIELD.USAGE_DETAILS.label}>
            <Text
              style={{
                fontFamily: "Pretendard",
                fontSize: "10pt",
              }}
            >
              ￦
              {details.map((detail: any) =>
                detail.map((cell: any) => formatNumber(cell)),
              )}
            </Text>
          </DocumentDetail.Field>

          <DocumentDetail.Field label={FIELD.USAGE_TYPE.label}>
            <Text
              style={{
                fontFamily: "Pretendard",
                fontSize: "10pt",
              }}
            >
              {usageTypeText || BLANK_PLACEHOLDER}
            </Text>
          </DocumentDetail.Field>

          <DocumentDetail.Field label={FIELD.USAGE_REASON.label}>
            <Text
              style={{
                fontFamily: "Pretendard",
                fontSize: "10pt",
              }}
            >
              {documentData[FIELD.USAGE_REASON.key] || BLANK_PLACEHOLDER}
            </Text>
          </DocumentDetail.Field>

          <DocumentDetail.Field label={FIELD.USAGE_CLIENTS.label}>
            {clients.map((row: any, ridx: number) => (
              <View key={ridx}>
                {row.map((cell: any, cidx: number) => (
                  <View key={cidx}>
                    <Text
                      style={{
                        fontFamily: "Pretendard",
                        fontSize: "10pt",
                      }}
                    >
                      - {labels[cidx]} : {cell}
                    </Text>
                  </View>
                ))}
              </View>
            ))}
          </DocumentDetail.Field>
        </DocumentDetail.Section>
      </div>
    </>
  );
};

export default CorpCardUsageProofDetail;
